import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import type { FlexItemProps } from '@/components/atomic/atoms/layout/flex-item/typings';
import { BasicComponentProps } from '@/typings/generic';
import { generateStylesheetRules } from '@/utils/generate-stylesheet-rules';
import styled, { CSSObject } from '@emotion/styled';

const FlexItem = styled(FlexContainer)<FlexItemProps & BasicComponentProps>(({
	$flex,
	$breakpoints,
	$order,
	$lineHeight,
	$alignSelf,
	$alignItems,
}) => {
	const flexItemProps = {
		$flex,
		$order,
		$lineHeight,
		$alignSelf,
		$alignItems,
	};
	const style: CSSObject = generateStylesheetRules(
		flexItemProps,
		Object.keys(flexItemProps),
	);

	if ($breakpoints !== undefined) {
		Object.entries($breakpoints).forEach(([breakpoint, props]) => {
			const breakpointKey = `@media (min-width: ${breakpoint}px)`;

			const nestedStyle: CSSObject = generateStylesheetRules(
				props,
				Object.keys(props),
			);

			if (!style[breakpointKey]) style[breakpointKey] = nestedStyle;
		});
	}

	return style;
});

export default FlexItem;
